import {useState, useEffect} from "react"
import AuthStream from "../../streams/auth"
import {OnError, OnComplete} from "../../streams/auth/base"

interface Props {
  onError?: OnError,
  onComplete?: OnComplete
}

export default function useAuth({onError, onComplete}: Props) {
  const [auth, setAuth] = useState(AuthStream.get())

  useEffect(() => {
    const subscription = AuthStream.subscribe((newAuth) => setAuth(newAuth), onError, onComplete)

    return () => {
      return subscription.unsubscribe()
    }
  }, [])

  return auth
}
